import { useState, useEffect } from "react";
import HiTrustLogo from "../../assets/images/HITRUSTCSFCertifiedLogo_white.png";
import PoweredByAWS from "../../assets/images/poweredby-aws.png";
import { getDomainFromUrl } from "../../utils/domainUtilities";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [domainFooter, setDomainFooter] = useState(null);

  useEffect(() => {
    const initializeFooter = async () => {
      try {
        const customFooter = await import(
          "../../custom_portal/" + getDomainFromUrl(window.location.hostname) + "/components/shared/Footer"
        );

        setDomainFooter(customFooter.default());
      } catch (error) {
        setDomainFooter(DefaultBox);
      }
    };

    initializeFooter();
  }, []);

  const DefaultBox = (
    <div className="ses_footer">
      <div className="ses-footer animate slide delay-2">
        <footer>
          <div className="ses-footer-container">
            <div className="ses-directTrust" title="Direct Trust Certification DTAAP HISP DTAAP CA DTAAP RA" ></div>
            {/*<div className="ses-drummond" title="Drummond Certification"></div>*/}
          </div>
          <div className="right-container">
            <div className="poweredby-aws">
              <a href="http://hitrustalliance.net" target="_blank" rel="noreferrer" >
                <img src={HiTrustLogo} className="hitrust-img" alt="HITRUST logo" title="HITRUST Logo" />
              </a>
              <img src={PoweredByAWS} alt="aws powered by logo" title="Powered by AWS" />
            </div>
            <div className="contact-footer">
              <b>Technical Support:</b> 1.888.470.9913 | <a href="mailto:support@secureexsolutions.com"> support@secureexsolutions.com </a>
            </div>
            <div className="copyright">
              For more information about our ONC certification please visit <a href="http://www.secureexsolutions.com/ONC" target="_blank" rel="noreferrer" > secureexsolutions.com/ONC </a>
              <br />
              Copyright &copy; {currentYear} | <a href="http://secureexsolutions.com/" target="_blank" rel="noreferrer" > Secure Exchange Solutions </a> | Powered by SES Direct | <a href="http://www.secureexsolutions.com/privacy-policy/" target="_blank" rel="noreferrer" > Privacy Policy and Terms of Use </a>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
  return <div>{domainFooter}</div>;
};

export default Footer;
